import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';
import PropTypes from 'prop-types';

function WelcomePageTimer({ startTime, setIsStart })
{
	const [ timeLeft, setTimeLeft ] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

	useEffect(() =>
	{
		let timer;
		const calculateTimeLeft = () =>
		{
			const now = new Date();
			const meetingTime = new Date(startTime);
			const diff = meetingTime - now;

			console.log('diffdiff', diff);

			if (diff > 0)
			{
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((diff % (1000 * 60)) / 1000);

				setTimeLeft({ days, hours, minutes, seconds });
			}
			else
			{
				setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 }); // Time is up
				setIsStart();
				clearInterval(timer);
			}
		};

		if (startTime)
		{
			calculateTimeLeft(); // Initial calculation
			timer = setInterval(calculateTimeLeft, 1000); // Declare and initialize timer
		}

		return () =>
		{
			clearInterval(timer); // Cleanup on unmount
		};
	}, [ startTime ]);

	console.log('timeLefttimeLefttimeLeft', timeLeft);

	return (
		<div className='flexRow jBtwn'>
			<div className='flexAutoCol gap16 aCntr'>
				<div className='flexAutoCol tme'><h2>{timeLeft?.hours ? (timeLeft?.hours > 9 ? timeLeft?.hours : `0${timeLeft?.hours}`) : '00'}</h2></div>
				<span>Hrs</span>
			</div>
			<div className='flexAutoCol pdngTSM aCntr gap16 dotCntr'>
				<span>.</span>
				<span>.</span>
			</div>
			<div className='flexAutoCol gap16 aCntr'>
				<div className='flexAutoCol tme'><h2>{timeLeft?.minutes ? (timeLeft?.minutes > 9 ? timeLeft?.minutes : `0${timeLeft?.minutes}`) : '00'}</h2></div>
				<span>Mins</span>
			</div>
			<div className='flexAutoCol pdngTSM aCntr gap16 dotCntr'>
				<span>.</span>
				<span>.</span>
			</div>
			<div className='flexAutoCol gap16 aCntr'>
				<div className='flexAutoCol tme'><h2>{timeLeft?.seconds ? (timeLeft?.seconds > 9 ? timeLeft?.seconds : `0${timeLeft?.seconds}`) : '00'}</h2></div>
				<span>Secs</span>
			</div>

		</div>
	);
}

WelcomePageTimer.propTypes =
{
	calculateRemainingTime : PropTypes.any,
	startTime              : PropTypes.any,
	setRemainingTime       : PropTypes.any,
	setIsStart             : PropTypes.any
};

// const mapStateToProps = (state) =>
// {
// 	return {
// 		webinarData	: state.webinar.webinarData
// 	};
// };

export default withRoomContext(connect(
	null,
	null,
	null
)(WelcomePageTimer));
